import { dataProps, measurementListProps, measurementDropDownListProps } from './properties'

export const setMeasurementTemplateList = (state, payload) => {
    state.list = payload
    
}    

export const setMeasurementTemplateData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.measurement_list.length === 0) {
        state.props.measurement_list = [JSON.parse(JSON.stringify(measurementListProps))]
    }

    state.props.measurement_list.forEach(element => {
        element.measurement_drop_down_list = [JSON.parse(JSON.stringify(measurementListProps))]
    })

    state.props.measurement_list = state.props.measurement_list.sort( (a,b) => { 
        var x = a.sl_no < b.sl_no? -1:1; 
        return x; 
    });
} 

export const addNewMeasurementListItemRow = state => {

    let sl_no = 0
    state.props.measurement_list.push(JSON.parse(JSON.stringify(measurementDropDownListProps)))

    state.props.measurement_list.forEach(element => {
        element.sl_no = sl_no
        sl_no ++
    })

    setTimeout(() => {
        document.getElementById('measurement_name_'+(sl_no-1)).focus()
    }, 300);

}

export const removeMeasurementListItemRow = (state, payload) => {

    let sl_no = 0

    state.props.deleted_measurement_list_items.push(state.props.measurement_list[payload])

    state.props.measurement_list.splice(payload, 1)

    if(state.props.measurement_list.length === 0) {
        state.props.measurement_list = [JSON.parse(JSON.stringify(measurementListProps))]
    }

    state.props.measurement_list.forEach(element => {
        element.sl_no = sl_no
        sl_no ++
    })

}

export const sortMeasurementTemplateList = (state, payload) => {

    let key = (payload.sl_no)

    if(payload.sort == 1) {
        state.props.measurement_list[key].sl_no = payload.sl_no+1
        state.props.measurement_list[key+1].sl_no = payload.sl_no         
    } else if(payload.sort == 0) {
        state.props.measurement_list[key].sl_no = payload.sl_no-1
        state.props.measurement_list[key-1].sl_no = payload.sl_no         
    }

    state.props.measurement_list = state.props.measurement_list.sort( (a,b) => { 
        var x = a.sl_no < b.sl_no? -1:1; 
        return x; 
    });

}

export const addNewMeasurementListDropDownItemRow = (state, parent_key) => {

    let key = 0
    state.props.measurement_list[parent_key].measurement_drop_down_list.push(JSON.parse(JSON.stringify(measurementDropDownListProps)))

    state.props.measurement_list[parent_key].measurement_drop_down_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        //document.getElementById('measurement_value_'+(key-1)).focus()
    }, 300);

}

export const removeMeasurementListDropDownItemRow = (state, payload) => {

    let key = 0

    state.props.measurement_list[payload.parent_key].deleted_measurement_drop_down_list_items.push(state.props.measurement_list[payload.parent_key].measurement_drop_down_list[payload.key])

    state.props.measurement_list[payload.parent_key].measurement_drop_down_list.splice(payload.key, 1)

    if(state.props.measurement_list[payload.parent_key].measurement_drop_down_list.length === 0) {
        state.props.measurement_list[payload.parent_key].measurement_drop_down_list = [JSON.parse(JSON.stringify(measurementDropDownListProps))]
    }

    state.props.measurement_list[payload.parent_key].measurement_drop_down_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const resetMeasurementTemplateData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementTemplate/mutations.js